module.exports = __webpack_public_path__ + "static/media/logo-holding.bbee6226.png";